import { ThomasCompany } from "./new-thomas-client";

export class NewThomasCompany {
    tenantKey: string;
    company: ThomasCompany;
    createdBy: string
}
